"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SVGCircleBadge_1 = require("./SVGCircleBadge");
exports.SVGCircleBadge = SVGCircleBadge_1.default;
var SVGSquareBadge_1 = require("./SVGSquareBadge");
exports.SVGSquareBadge = SVGSquareBadge_1.default;
var SVGHexagonBadge_1 = require("./SVGHexagonBadge");
exports.SVGHexagonBadge = SVGHexagonBadge_1.default;
var SVGStackBadge_1 = require("./SVGStackBadge");
exports.SVGStackBadge = SVGStackBadge_1.default;
//# sourceMappingURL=index.js.map